
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
    <div class="content">
      <div class="page_container">
        <h1>
          <img class="title" src="../assets/sumire/img/wellcome_title.png" alt="">
        </h1>
        <div class="question_block">
          <p>
            {{questionCaption}}
          </p>
        </div>
        <div class="btn_block">
          <div class="answer_btn"  @click="sendAnswer(button1Value)" id="yes">
            <p>{{button1Caption}}</p>
              <ons-ripple ></ons-ripple>
          </div>
          <div class="answer_btn"  @click="sendAnswer(button2Value)" id="no">
            <p>{{button2Caption}}</p>
              <ons-ripple ></ons-ripple>
          </div>
        </div>
        
        <div>
          <img class="footer_img" src="../assets/sumire/img/best_smile.png" alt="">
        </div>
      </div>
    </div>
    
  </v-ons-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'blank',
  data() {
    return {}
  },
  created: function() {
    if(this.repeater_token!=''){
      this.moveNextPage()
    }
  },
  computed: {
    ...mapGetters([
      'repeater_token',
      'currentLangCode',
      'RepeaterSetting',
      'LinePageEnabled',
      ]),
      questionCaption(){
        if(this.currentLangCode=='ja'){
          return this.RepeaterSetting.repeater_page_question
        }else if(this.currentLangCode=='en'){
          return this.RepeaterSetting.repeater_page_question_en
        }else if(this.currentLangCode=='ch'){
          return this.RepeaterSetting.repeater_page_question_ch
        }
        
        
      },
      button1Caption(){
        if(this.currentLangCode=='ja'){
          return this.RepeaterSetting.repeater_page_answer_1_caption
        }else if(this.currentLangCode=='en'){
          return this.RepeaterSetting.repeater_page_answer_1_caption_en
        }else if(this.currentLangCode=='ch'){
          return this.RepeaterSetting.repeater_page_answer_1_caption_ch
        }
      },
      button2Caption(){
        if(this.currentLangCode=='ja'){
          return this.RepeaterSetting.repeater_page_answer_2_caption
        }else if(this.currentLangCode=='en'){
          return this.RepeaterSetting.repeater_page_answer_2_caption_en
        }else if(this.currentLangCode=='ch'){
          return this.RepeaterSetting.repeater_page_answer_2_caption_ch
        }
      },
      button1Value(){
        if(this.currentLangCode=='ja'){
          return this.RepeaterSetting.repeater_page_answer_1_val
        }else if(this.currentLangCode=='en'){
          return this.RepeaterSetting.repeater_page_answer_1_val_en
        }else if(this.currentLangCode=='ch'){
          return this.RepeaterSetting.repeater_page_answer_1_val_ch
        }
      },
      button2Value(){
        if(this.currentLangCode=='ja'){
          return this.RepeaterSetting.repeater_page_answer_2_val
        }else if(this.currentLangCode=='en'){
          return this.RepeaterSetting.repeater_page_answer_2_val_en
        }else if(this.currentLangCode=='ch'){
          return this.RepeaterSetting.repeater_page_answer_2_val_ch
        }
      },
  },
  methods: {
    ...mapActions([
      'navigatePage',
      'navigateWPPage',
      'SendRepeaterAnswer',
      'setSessionToken',
      'setRepeaterToken',
    ]),
    moveNextPage(){
      var self=this
      if(self.LinePageEnabled=='true'){
        self.setRepeaterToken()
        self.navigatePage('line_friend') //LINEお友達登録ページへ遷移
      }else{
        debugger
        self.setRepeaterToken()
        self.setSessionToken()
        self.navigateWPPage('menu_top')
      }
      
    },
    sendAnswer(val){
      var self=this
      this.SendRepeaterAnswer({
        question: this.questionCaption,
        answer: val,
        term_info: navigator.userAgent.substr(0,50),
      })
      .then(()=>{
        self.moveNextPage()
      }).catch(error=>{
        //送信失敗
        self.moveNextPage()
      })
    },
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
* {
  box-sizing: border-box;
}
/*
.content.start{
    padding: 20% 10% 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: url(../assets/img/home_bg.jpg) no-repeat!important;
    background-size: cover!important; 
    background-position: center;
    color: $base-font-color;
  }
  */
.content{
     position: relative;
     height:100vh;
    background-color:white!important;
    img{
      max-width:100%;
    }
}
.page_container{
  height:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content:space-between;
    padding:0 20px 60px;
    
}
.footer_img{
}
.question_block{
  background-color:#EDEDED;
  padding: 20px;
  border-radius: 10px;
  width:100%;
  height:25vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:18px;
  font-weight: bold;
}
.answer_btn{
  border: 1px solid #222;
  border-radius: 5px;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.btn_block{
  width:100%;
}
/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/RepeaterAnswerPage.vue